import { useEffect, useState } from "react";
import { ShieldAlert } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "@/lib/api";
import { Panel, Spinner } from "@/components/common";
import { Switch } from "@/components/ui/switch";

export default function ServingAlerts() {
  const [s, setS] = useState(null);
  const [preview, setPreview] = useState(null);
  const [busy, setBusy] = useState("");
  useEffect(() => { api.get("/serving-alerts/settings").then((r) => setS(r.data)).catch(() => setS({ enabled: true, time: "09:00" })); }, []);
  const toggle = async (v) => {
    setS({ ...s, enabled: v });
    try { setS((await api.put("/serving-alerts/settings", { enabled: v })).data); toast.success(v ? "Serving alerts on" : "Serving alerts off"); } catch (e) { toast.error(errMsg(e)); }
  };
  const check = async (send) => {
    setBusy(send ? "send" : "check");
    try { const { data } = await api.post("/serving-alerts/test", { send }); setPreview(data); if (send) toast.success(data.sent ? "TEST serving email sent" : "Nothing to send: all healthy"); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(""); }
  };
  if (!s) return <Spinner />;
  const last = s.last_result;
  return (
    <Panel title="Serving alerts" icon={ShieldAlert} testid="serving-alerts-panel">
      <p className="mb-4 text-sm text-slate-400">Every day at 9:00am SGT, Ads Monster checks the 3 TRL campaigns and emails you only if something is wrong: not serving, an ad disapproved or limited, 0 impressions yesterday, or keywords with low search volume. Unresolved issues repeat every 3 days.</p>
      <div className="flex flex-wrap items-center gap-4 text-sm text-slate-300">
        <label className="flex items-center gap-2"><Switch data-testid="serving-enabled-switch" checked={s.enabled} onCheckedChange={toggle} /> Daily check at 9:00am</label>
        <button data-testid="serving-check-now-btn" onClick={() => check(false)} disabled={!!busy} className="cc-btn cc-btn-ghost px-3 py-1.5 text-xs">{busy === "check" ? <Spinner className="h-3.5 w-3.5" /> : null} Send test serving check now</button>
      </div>
      {last && <div className="mt-3 text-xs text-slate-500" data-testid="serving-last-result">Last run {fmtDate(last.at)}: {last.skipped ? `skipped (${last.skipped})` : `${last.issues} issue(s), ${last.sent ? `emailed ${last.due}` : "no email"}`}</div>}
      {preview && (
        <div className="mt-4 rounded border border-[#1e293b] p-3" data-testid="serving-preview">
          {preview.issues.length === 0 ? <div className="text-sm text-emerald-300">All healthy: no email would be sent.</div> : (
            <>
              <ul className="space-y-1.5 text-xs text-slate-300">{preview.issues.map((i) => <li key={i.key}><b className="text-amber-300">{i.campaign.replace("TRL | ", "")}</b>: {i.what}. <span className="text-slate-500">{i.todo}</span></li>)}</ul>
              <button data-testid="serving-send-test-btn" onClick={() => check(true)} disabled={!!busy} className="cc-btn cc-btn-primary mt-3 px-3 py-1.5 text-xs">Send this as a TEST email</button>
            </>)}
          <div className="mt-2 text-[10px] text-slate-500">Data: {preview.source === "live" ? "1 live check (sync was stale)" : "latest daily sync"}</div>
        </div>)}
    </Panel>
  );
}
